import { render } from "./GlyphBlock.vue?vue&type=template&id=cf5cc51e"
import script from "./GlyphBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./GlyphBlock.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/apps/GlyphBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cf5cc51e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cf5cc51e', __exports__)) {
    api.reload('cf5cc51e', __exports__)
  }
  
  module.hot.accept("./GlyphBlock.vue?vue&type=template&id=cf5cc51e", () => {
    api.rerender('cf5cc51e', render)
  })

}


export default __exports__